/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import { combineReducers } from 'redux'
import logonReducer from '../views/Logon/state/reducer'
import app from '../views/App/state/reducer'
import agreementReducer from '../views/Agreement/state/reducer'
import intl from '../shared/containers/IntlProvider/state/reducers'
import accountQuestion from '../views/AccountQuestion/state/reducer'
import previewQuestion from '../views/PreviewQuestion/state/reducer'
import basicInfo from '../views/BasicInfo/state/reducer'
import fileUploadInfo from '../views/FileUploadInfo/state/reducer'
import help from '../views/Help/state/reducer'
import appointReducer from '../views/Appointment/state/reducer'
import applicantInformationReducer from '../views/ApplicantInformation/state/reducer'
import companyRegistrationReducer from '../views/CompanyRegistration/state/reducer'
import accountOpeningStepsReducer from '../views/AccountOpeningSteps/state/reducer'
import dashboard from '../views/AOFormReview/state/reducer'

const rootReducer = combineReducers({
    logonReducer,
    app,
    agreementReducer,
    accountQuestion,
    previewQuestion,
    basicInfo,
    intl,
    fileUploadInfo,
    help,
    appointReducer,
    applicantInformationReducer,
    companyRegistrationReducer,
    accountOpeningStepsReducer,
    dashboard
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/rootReducer.js